import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { OfferIntro } from './components/OfferIntro';
import { BenefitsSection } from './components/BenefitsSection';
import { SocialProofSection } from './components/SocialProofSection';
import { OfferDetails } from './components/OfferDetails';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen flex flex-col font-sans text-ink bg-cream-light" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <OfferIntro data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <SocialProofSection data-id="element-6" />
        <OfferDetails data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}